import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { socialAPI } from '../services/api';
import { t } from '../i18n';
import { useAuth } from '../context/AuthContext';

function VideoInfo({ video, isMuted, toggleMute }) {
  const navigate = useNavigate();
  const { user: currentUser } = useAuth();
  const [following, setFollowing] = useState(false);
  const [expanded, setExpanded]   = useState(false);
  const [activeTab, setActiveTab] = useState('foryou');
  const caption = video.description || '';
  const isLong  = caption.length > 70;

  const handleFollow = async (e) => {
    e.stopPropagation();
    try {
      if (following) { await socialAPI.unfollowUser(video.creator?.id); }
      else           { await socialAPI.followUser(video.creator?.id); }
      setFollowing(!following);
    } catch(e) {}
  };

  return (
    <div style={{ fontFamily:"'DM Sans',sans-serif" }}>

      {/* Caption */}
      {caption && (
        <p onClick={(e) => { e.stopPropagation(); setExpanded(!expanded); }}
          style={{ color:'rgba(255,255,255,0.92)', fontSize:13, lineHeight:1.45,
            margin:'0 0 6px 0', cursor:'pointer', textShadow:'0 1px 4px rgba(0,0,0,0.8)' }}>
          {expanded || !isLong ? caption : caption.slice(0, 70)}
          {isLong && !expanded && <span style={{ color:'rgba(255,255,255,0.55)', fontSize:12 }}> ...more</span>}
        </p>
      )}

      {/* Description / Skills / Services */}
      <div style={{ display:'flex', alignItems:'flex-start', gap:6, marginBottom:8 }}>
        {/* Italic golden I icon */}
        <span style={{
          fontSize:15, flexShrink:0,
          fontStyle:'italic', fontWeight:900,
          color:'#E6C76A',
          fontFamily:'Georgia,serif',
          textShadow:'0 0 8px rgba(230,199,106,0.7)',
          lineHeight:1.4,
        }}>I</span>
        <div style={{ overflow:'hidden', flex:1 }}>
          <div style={{ display:'inline-block', whiteSpace:'nowrap', fontSize:12,
            color:'rgba(255,255,255,0.85)', fontWeight:500,
            textShadow:'0 1px 4px rgba(0,0,0,0.8)',
            animation: video.description && video.description.length > 40 ? 'marqueeScroll 10s linear infinite' : 'none' }}>
            {video.description
              ? video.description + (video.description.length > 40 ? '     ' + video.description : '')
              : `@${video.creator?.username || 'unknown'} · IcingShow`}
          </div>
        </div>
      </div>

      {/* Single row: avatar | @username | Follow | Mute | Following | iShows */}
      <div style={{ display:'flex', alignItems:'center', gap:6, flexWrap:'nowrap', width:'100%', minWidth:0 }}>

        {/* Avatar */}
        <div onClick={(e) => { e.stopPropagation(); if (!video.creator?.id) return; if (currentUser && video.creator.id === currentUser.id) { navigate('/profile'); } else { navigate(`/profile/${video.creator.id}`); } }}
          style={{ width:32, height:32, borderRadius:'50%', border:'2px solid #fff',
            overflow:'hidden', background:'linear-gradient(135deg,#667eea,#764ba2)',
            display:'flex', alignItems:'center', justifyContent:'center',
            cursor:'pointer', flexShrink:0 }}>
          {video.creator?.profile_picture
            ? <img src={video.creator.profile_picture} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }} />
            : <span style={{ color:'#fff', fontWeight:700, fontSize:13 }}>
                {video.creator?.username ? video.creator.username[0].toUpperCase() : '?'}
              </span>}
        </div>

        {/* Username */}
        <span onClick={(e) => { e.stopPropagation(); if (!video.creator?.id) return; if (currentUser && video.creator.id === currentUser.id) { navigate('/profile'); } else { navigate(`/profile/${video.creator.id}`); } }}
          style={{ color:'#fff', fontSize:13, fontWeight:700, cursor:'pointer',
            textShadow:'0 1px 6px rgba(0,0,0,0.9)', flexShrink:1, minWidth:0, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', maxWidth:'25%' }}>
          @{video.creator?.username || 'unknown'}
        </span>

        {/* Follow — plain text style matching Following/iShows tabs */}
        <button onClick={handleFollow} style={{
            background:'none', border:'none', cursor:'pointer',
            fontSize:11, fontFamily:'DM Sans, sans-serif',
            color: following ? '#fff' : 'rgba(255,255,255,0.5)',
            fontWeight: following ? 700 : 400,
            padding:'2px 0', position:'relative',
            touchAction:'manipulation', flexShrink:0,
          }}>
            {following ? 'Following' : 'Follow'}
            {following && (
              <div style={{ position:'absolute', bottom:-3, left:'50%', transform:'translateX(-50%)',
                width:14, height:2, background:'#fff', borderRadius:2 }} />
            )}
        </button>

        {/* Mute */}
        <button onTouchEnd={toggleMute} onClick={toggleMute}
          style={{ background:'rgba(0,0,0,0.55)', backdropFilter:'blur(8px)',
            border:'1px solid rgba(255,255,255,0.25)', borderRadius:'50%',
            width:28, height:28, display:'flex', alignItems:'center', justifyContent:'center',
            color:'#fff', fontSize:12, cursor:'pointer', touchAction:'manipulation', flexShrink:0 }}>
          {isMuted ? '🔇' : '🔊'}
        </button>

        {/* Following | iShows tabs */}
        <div style={{ width:6 }} />
        <button
          onClick={(e) => { e.stopPropagation(); setActiveTab('following'); }}
          style={{ background:'none', border:'none', cursor:'pointer',
            fontSize:11, fontFamily:'DM Sans, sans-serif',
            color: activeTab==='following' ? '#fff' : 'rgba(255,255,255,0.5)',
            fontWeight: activeTab==='following' ? 700 : 400,
            padding:'2px 0', position:'relative', touchAction:'manipulation', flexShrink:0 }}>
          {t('following')}
          {activeTab==='following' && (
            <div style={{ position:'absolute', bottom:-3, left:'50%', transform:'translateX(-50%)',
              width:14, height:2, background:'#fff', borderRadius:2 }} />
          )}
        </button>
        <button
          onClick={(e) => { e.stopPropagation(); navigate('/contract'); }}
          style={{ background:'none', cursor:'pointer',
            fontSize:13, fontFamily:'DM Sans, sans-serif',
            color:'#fff', fontWeight:800,
            padding:'2px 8px', touchAction:'manipulation', flexShrink:0,
            borderLeft:'2.5px solid #fff', borderRight:'2.5px solid #fff',
            borderTop:'none', borderBottom:'none',
            letterSpacing:'0.01em',
          }}>
          Contract
        </button>
      </div>
    </div>
  );
}

export default VideoInfo;
